export const UserModel = () => {

    const createUserModel = (obj) => {
        return {
            email: obj.email,
            fullname: obj.fullName,
            password: obj.password,
            pricing_agreement: obj.pricing || true,
            privacy_policy: !!obj.privacy,
            terms_of_service: !!obj.terms
        }
    }

    return Object.freeze({
        createUserModel
    })
}